import { useEffect, useState, useRef } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import { Link } from "react-router-dom";
import API_BASE_URL from '../../../constants/api';
import axios from 'axios';

const tab_title: string[] = ["All Courses"];

// Swiper settings WITHOUT hardcoding nav elements (set in onInit)
const setting = {
  slidesPerView: 4,
  loop: true,
  spaceBetween: 30,
  observer: true,
  observeParents: true,
  autoplay: false,
  navigation: {
    nextEl: null,
    prevEl: null,
  },
  breakpoints: {
    '1500': { slidesPerView: 4 },
    '1200': { slidesPerView: 4 },
    '992': { slidesPerView: 3, spaceBetween: 24 },
    '768': { slidesPerView: 2, spaceBetween: 24 },
    '576': { slidesPerView: 1 },
    '0': { slidesPerView: 1 },
  },
};

interface CourseProps {
  style: boolean;
}

interface CourseData {
  course_id: number;
  title: string;
  thumb: string;
  course_image: string;
  tag: string;
  review: string;
  price: string;
  lesson: string;
  minute: string | null;
  student: number | null;
  desc: string | null;
  language: string | null;
  country: string | null;
  overview?: {
    description: string;
    extraNote: string;
    learnings: string[];
  };
  badges?: string[];
}

interface CoursesApiResponse {
  page: string;
  courses: CourseData[];
}

const CourseArea = ({ style }: CourseProps) => {
  const [activeTab, setActiveTab] = useState(0);
  const [courses, setCourses] = useState<CourseData[]>([]);

  const prevRef = useRef<HTMLDivElement | null>(null);
  const nextRef = useRef<HTMLDivElement | null>(null);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth < 768);
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, [])

  const handleTabClick = (index: number) => {
    setActiveTab(index);
  };

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const res = await axios.get<CoursesApiResponse>(`${API_BASE_URL}courses/home_1`);
        setCourses(res.data.courses);
      } catch (err) {
        console.error('Error fetching courses:', err);
      }
    };

    fetchCourses();
  }, []);

  return (
    <section
      className={`courses-area ${style ? "section-py-120" : "section-pt-120 section-pb-90"}`}
      style={{ backgroundImage: `url(/assets/img/bg/courses_bg.jpg)` }}
    >
      <div className="container">
        <div className="section__title-wrap">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="section__title text-center mb-40">
                <span className="sub-title">Courses for You</span>
                <h2 className="title">Pave the foundation with core skills</h2>
                <p className="desc">
                  Gain practical experience as you cover concepts. Catch up as you study the subjects.
                </p>
              </div>
              <div className="courses__nav">
                <ul className="nav nav-tabs" id="courseTab" role="tablist">
                  {tab_title.map((tab, index) => (
                    <li
                      key={index}
                      onClick={() => handleTabClick(index)}
                      className="nav-item"
                      role="presentation"
                    >
                      <button className={`nav-link ${activeTab === index ? "active" : ""}`}>
                        {tab}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="tab-content" id="courseTabContent">
          <div
            className={`tab-pane fade show active`}
            id="all-tab-pane"
            role="tabpanel"
            aria-labelledby="all-tab"
          >
            <Swiper
              {...setting}
              modules={[Autoplay, Navigation]}
              className="swiper courses-swiper-active"
              navigation={{
                prevEl: prevRef.current,
                nextEl: nextRef.current,
              }}
              onInit={(swiper) => {
                if (
                  swiper.params.navigation &&
                  typeof swiper.params.navigation !== 'boolean'
                ) {
                  swiper.params.navigation.prevEl = prevRef.current;
                  swiper.params.navigation.nextEl = nextRef.current;
                  swiper.navigation.init();
                  swiper.navigation.update();
                }
              }}
            >
              {courses.map((item) => (
                <SwiperSlide key={item.course_id} className="swiper-slide">
                  <div className="courses__item shine__animate-item">
                    <div style={{ marginBottom: '10px' }}>
                      <Link to={`/course-details/${item.course_id}`} className="shine__animate-link">
                        <img src={item.thumb} alt="img" />
                      </Link>
                    </div>
                    <div className="courses__item-content">
                      <ul className="courses__item-meta list-wrap">
                        <li className="courses__item-tag">
                          <Link to="/course">{item.tag}</Link>
                        </li>
                        <li className="courses__item-tag">
                          <i className="fas fa-calendar-alt"></i> {item.lesson}
                        </li>
                      </ul>
                      <h5 className="title">
                        <Link to={`/course-details/${item.course_id}`}>{item.title}</Link>
                      </h5>
                      <div className="courses__item-bottom">
                        <div className="button">
                          <Link to={`/course-details/${item.course_id}`}>
                            <span className="text">Enroll Now</span>
                            <i className="flaticon-arrow-right"></i>
                          </Link>
                        </div>
                        <h5 className="price">₹{item.price}</h5>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {!style  &&  isMobile &&(
              <div className="courses__nav">
                <div ref={prevRef} className="courses-button-prev">
                  <i className="flaticon-arrow-right"></i>
                </div>
                <div ref={nextRef} className="courses-button-next">
                  <i className="flaticon-arrow-right"></i>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CourseArea;
